import { render, staticRenderFns } from "./DocumentEditor.vue?vue&type=template&id=2738b91a&scoped=true&"
import script from "./DocumentEditor.vue?vue&type=script&lang=js&"
export * from "./DocumentEditor.vue?vue&type=script&lang=js&"
import style0 from "./DocumentEditor.vue?vue&type=style&index=0&id=2738b91a&prod&lang=css&"
import style1 from "./DocumentEditor.vue?vue&type=style&index=1&id=2738b91a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2738b91a",
  null
  
)

export default component.exports